module.exports = __webpack_public_path__ + "static/media/coatmax.61dade2f.jpg";